export const cloneControl = {
  defaultButton: `استنساخ`,
  defaultNoun: `الإعدادات`,
  itemNounDefault: `هذه الإعدادات`,
  pullTitle: `جلب الإعدادات من إقامة أخرى`,
  pushTitle: `نسخ هذه الإعدادات إلى إقامة أخرى`,
  pullSubReplace: `ستُطبَّق على هذه الإقامة`,
  pullSubAdd: `ستُضاف إلى إعدادات هذه الإقامة`,
  pushSubReplace: `ستُطبَّق على الإقامات التي تختارها`,
  pushSubAdd: `ستُضاف إلى إعدادات الإقامات التي تختارها`,
  pullTitleFull: `جلب {noun}`,
  pushTitleFull: `نسخ {noun}`,
  pullSubtitle: `اختر الإقامة التي تريد جلب الإعدادات منها. ستُطبّق على هذه الإقامة.`,
  pushSubtitle: `انسخ هذه الإعدادات إلى الإقامات التي تختارها.`,
};
